//============================
// TABLE FUNCTIONS
//============================

export async function getArTableList(fileUrl, sessionId: string, client: any) {
  let arTables = [];
  // LOOK FOR THE AR TABLES
  const tablesUrl = fileUrl + "/workbook/tables";
  try {
    let tableInfo = await client
      .api(tablesUrl)
      .header("workbook-session-id", sessionId)
      .get();
    // get the helper tables
    tableInfo.value?.forEach((tempTable) => {
      if (tempTable.name.includes("AR_")) {
        arTables.push(tempTable.name);
      }
    })
  } catch (err) {
    console.log("ERROR getArTableList", err);
  }
  return arTables;
}

async function createWorksheet(fileUrl, sessionId, client, worksheetName) {
  // add the worksheet
  let resWorksheet = await client.api(fileUrl + '/workbook/worksheets/add')
  .header("workbook-session-id", sessionId)
  .post({ name: worksheetName })
  .catch(error => {
    console.error('Error adding worksheet', error);
  });
  return resWorksheet?.id;
}

async function createWorksheetTable(fileUrl, sessionId, client, worksheetId, tableArea, tableName) {
  // add the table
  const workbookTable = {
    address: tableArea,
    hasHeaders: true
  };  
  let res = await client
    .api(fileUrl + "/workbook/worksheets/"+worksheetId+"/tables/add")
    .header("workbook-session-id", sessionId)
    .post(workbookTable)
    .catch(error => {
      console.error('Error adding table', error);
    });
  const tableId = res?.id;
  // rename the table
  const workbookTableRename = {
    name: tableName,
    showHeaders: true,
    showTotals: false,
  };
  const resRename = await client
    .api(fileUrl + "/workbook/tables/"+tableId)
    .header("workbook-session-id", sessionId)
    .update(workbookTableRename)
    .catch(error => {
      console.error('Error renaming table', error);
    });
  const tableExists = (resRename.name === tableName);
  return tableExists;
}

//============================
// AR_LOG
//============================

export async function checkArLogTable(fileUrl, sessionId, client, createIfMissing) {
  const arTables = await getArTableList(fileUrl, sessionId, client);
  let tableExists = (arTables.findIndex((x) => x === "AR_LOG") !== -1);
  // create the table if missing
  if (!tableExists && createIfMissing) {
    // add the worksheet
    const worksheetId = await createWorksheet(fileUrl, sessionId, client, "AR_LOG");
    if (!worksheetId) { return false};
    // add the table
    tableExists = await createWorksheetTable(fileUrl, sessionId, client, worksheetId, "AR_LOG!A1:M1", "AR_LOG");
  }
  return tableExists;
}

//============================
// AR_INFO
//============================

export async function checkArInfoTable(fileUrl, sessionId, client, createIfMissing) {
  const arTables = await getArTableList(fileUrl, sessionId, client);
  let tableExists = (arTables.findIndex((x) => x === "AR_INFO") !== -1);
  // create the table if missing
  if (!tableExists && createIfMissing) {
    // add the worksheet
    const worksheetId = await createWorksheet(fileUrl, sessionId, client, "AR_INFO");
    if (!worksheetId) { return false};
    // add the table
    tableExists = await createWorksheetTable(fileUrl, sessionId, client, worksheetId, "AR_INFO!A1:G1", "AR_INFO"); //TODO_AR_INFO
  }
  return tableExists;
}

